<template>
  <input
    class="searchBar"
    type="search"
    :placeholder="$t('definitionsPage.search')"
    :value="searchTerm"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  props: ["searchTerm"],
};
</script>

<style scoped lang="scss">
.searchBar {
  top: 175px;
  left: 158px;
  width: 235px;
  height: 32px;
  padding-left: 8px;
  border: 1px solid #0003;
  border-radius: 2px;
  color: #3a3a3a;
  font-size: 16px;
  -webkit-appearance: none;

  &:focus {
    border: 1px solid #3a3a3a;
    outline: 0;
  }

  &:focus::placeholder {
    color: transparent;
  }

  &::placeholder {
    font-size: 16px;
  }

  &::-webkit-search-cancel-button {
    position: relative;
    right: 8px;
  }
}
</style>
